module.exports = __webpack_public_path__ + "static/media/1.44875bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/1.png
// module id = 34
// module chunks = 0